import {getCourierDropStatistics} from "./api.js";
import {useEffect, useState} from "react";

export const DropStatistics = ({user}) => {

  const [stats, setStats] = useState({})

  useEffect(() => {
    if(user.user_id){
      getCourierDropStatistics({userId: user.user_id}).then((data) => {
        setStats(data)
      })
    }
  }, [user])

  return <div className="flex gap-3 flex-wrap m-3">
    <div className="flex flex-col items-center w-32 border-2 rounded border-black border-solid p-2">
      <div>Всего сделано</div>
      <div className="text-5xl">{stats.total}</div>
    </div>
    <div className="flex flex-col items-center w-32 border-2 rounded border-black border-solid p-2">
      <div>Успешно снято</div>
      <div className="text-5xl">{stats.paid_and_completed}</div>
    </div>
    <div className="flex flex-col items-center w-32 border-2 rounded border-black border-solid p-2">
      <div>В процессе снятия</div>
      <div className="text-5xl">{stats.in_process}</div>
    </div>
    <div className="flex flex-col items-center w-32 border-2 rounded border-black border-solid p-2">
      <div>Не нашли</div>
      <div className="text-5xl">{stats.not_found}</div>
    </div>
    <div className="flex flex-col items-center w-32 border-2 rounded border-black border-solid p-2">
      <div>Диспуты в процессе</div>
      <div className="text-5xl">{stats.disputes_in_process}</div>
    </div>
  </div>

}
